export default "__VITE_ASSET__DEFayb7Q__"